<mat-form-field>
	<mat-label>{{ placeholder }}</mat-label>
	<input
		matInput
		#addressInput
		(keydown)="onKeydown($event)"
		[formControl]="myControl"
		autocomplete="off"
		(keypress)="_addressRestrictionKeysOnly($event)"
		[maxLength]="128"
	/>
	<div
		class="placeholder-image"
		*ngIf="placeholderImageUrl && !busy"
		[style.marginTop.px]="placeholderImageSize * -1 - 1"
	>
		<img
			[src]="placeholderImageUrl"
			[width]="placeholderImageSize"
			[height]="placeholderImageSize"
		/>
	</div>
	<div class="spinner" *ngIf="busy">
		<mat-spinner
			color="primary"
			[diameter]="15"
			[strokeWidth]="1.5"
		></mat-spinner>
	</div>
	<mat-hint *ngIf="!showAddressList()">
		e.g. 1 FLINDERS STREET MELBOURNE VIC 3000
	</mat-hint>
	<mat-error *ngIf="myControl.errors">{{ errorMessage }}</mat-error>
	<img
		*ngIf="showHintError"
		class="validation-tick"
		[src]="validationImage()"
	/>
</mat-form-field>
<ul class="suggested-addresses" *ngIf="showAddressList()">
	<li
		class="address"
		*ngFor="let address of addresses; let i = index"
		[class.active-option]="i == activeOptionIndex"
		(click)="autoCompleteAddressSelected(address)"
	>
		{{ address.Address }}
	</li>
	<li
		*ngIf="(queryVal && showManualEntryOption) || showAddressList()"
		class="address not-found"
		[class.active-option]="
			addresses && activeOptionIndex == addresses.length
		"
		(click)="autoCompleteAddressSelected(null)"
	>
		<span>Can't find your address?</span>
		<span class="accent-fg underline">Manual Search</span>
	</li>
</ul>